export default __webpack_public_path__ + "static/play-agent3-bop-english-84c36e50ac876a82ac7c97f7eea3d540.png";